import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "vw-button",
  templateUrl: "./button.component.html",
})
export class ButtonComponent {
  @Input() primary?: boolean;
  @Input() text?: string;
  @Input() type?: string;
  @Input() disabled?: boolean;
  @Input() large?: boolean;
  @Input() small?: boolean;
  @Input() rounded?: boolean;
  @Input() border?: boolean;
  @Input() icon?: string;
  @Input() light?: boolean;

  @Output() click$ = new EventEmitter<void>();

  constructor() {}

  click(): void {
    this.click$.emit();
  }
}
